import axios from 'axios';
import Dashboard from './main-views/Dashboard';
import CreateCustomer from './views/CreateCustomer';
import CreateMotorcycle from './views/CreateMotorcycle';
import CreatePayment from './views/CreatePayment';
import CreateSale from './views/CreateSale';
import CreateResale from './views/CreateResale';
import CreateAdmin from './views/CreateAdmin';
import CustomerOptions from './views/CustomerOptions';
import MotorcycleOptions from './views/MotorcycleOptions';
import DebtOptions from './views/DebtOptions';
import PaymentOptions from './views/PaymentOptions';
import EditDebt from './views/EditDebt';
import EditPayment from './views/EditPayment';
import SaleOptions from './views/SaleOptions';
import AdminOptions from './views/AdminOptions';
import Customers from './main-views/Customers';
import Sales from './main-views/Sales';
import Debts from './main-views/Debts';
import Payments from './main-views/Payments';
import Admins from './main-views/Admins';
import Reports from './main-views/Reports';
import Motorcycles from './main-views/Motorcycles';

export const BASE_API = 'https://bobapi.werenium.com/area222/';

export const CDN_URL = 'https://bob.werenium.com/cdn/'


export function getMainView(app) {
  if (app.navItem === 'dashboard') {
    return <Dashboard />
  } else if (app.navItem === 'customers') {
    return <Customers />
  } else if (app.navItem === 'admins') {
    return <Admins />
  } else if (app.navItem === 'debts') {
    return <Debts />
  } else if (app.navItem === 'motorcycles') {
    return <Motorcycles />
  } else if (app.navItem === 'sales') {
    return <Sales />
  } else if (app.navItem === 'payments') {
    return <Payments />
  }  else if (app.navItem === 'reports') {
    return <Reports />
  } else {
    return <Dashboard />
  }

  return null;
}

export function getViewerView(app) {
  
  if(
    app.navSubItem === 'create-customer' &&
    (!app.navExtraItem || app.navExtraItem) &&
    !app.navMoreItem
  ) {
    return <CreateCustomer uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'create-motorcycle' &&
    (!app.navExtraItem || app.navExtraItem) &&
    !app.navMoreItem
  ) {
    return <CreateMotorcycle uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'create-sale' &&
    (!app.navExtraItem || app.navExtraItem) &&
    !app.navMoreItem
  ) {
    return <CreateSale uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'create-resale' &&
    (!app.navExtraItem || app.navExtraItem) &&
    !app.navMoreItem
  ) {
    return <CreateResale uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'create-payment' &&
    (!app.navExtraItem || app.navExtraItem) &&
    !app.navMoreItem
  ) {
    return <CreatePayment uuid={app.navExtraItem}/>
  } else if (
    app.navSubItem === 'create-admin' &&
    (!app.navExtraItem || app.navExtraItem) &&
    !app.navMoreItem
  ) {
    return <CreateAdmin id={app.navExtraItem}/>;
  } 
  return null;
}

export function getSideViewerView(app) {
  
  if(
    app.navSubItem === 'customer-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <CustomerOptions uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'motorcycle-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <MotorcycleOptions uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'debt-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <DebtOptions uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'payment-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PaymentOptions uuid={app.navExtraItem}/>
  } else if(
    app.navSubItem === 'sale-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <SaleOptions uuid={app.navExtraItem}/>
  } else if (
    app.navSubItem === 'admin-options' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <AdminOptions id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'edit-debt' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <EditDebt uuid={app.navExtraItem} />;
  }  else if (
    app.navSubItem === 'edit-payment' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <EditPayment uuid={app.navExtraItem} />;
  } 

  return null;
}


export function getInlineLoader(options = {}) {
  const {
    variant = "inline",
    centered = true,
    text = "",
    label = "Loading",
    className = "",
  } = options;

  return (
    <div
      className={`Loader Loader--${variant} ${centered ? "Loader--centered" : ""} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="Loader-visual">
        <div className="Loader-orbit Loader-orbit--one"></div>
        <div className="Loader-orbit Loader-orbit--two"></div>
        <div className="Loader-core">
          <div className="Loader-coreDot"></div>
        </div>
      </div>
      {text ? <span className="Loader-text">{text}</span> : null}
    </div>
  )
}


export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      
      let formData = new FormData();

      // 1. Robust Recursive Function to handle nested Arrays, Objects, and Files
      const appendFormData = (data, parentKey) => {
        // If it is a standard object/array (but NOT a File, Blob, or Date)
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
          Object.keys(data).forEach(key => {
            // Build nested keys like: guarantors[0][fullname]
            const nextKey = parentKey ? `${parentKey}[${key}]` : key;
            appendFormData(data[key], nextKey);
          });
        } else {
          // If it is a primitive (string, number) or binary File, append it directly
          const value = data == null ? '' : data;
          formData.append(parentKey, value);
        }
      };

      // 2. Safely parse both params and user data
      appendFormData(params, '');
      appendFormData(user, '');

      axios.post(BASE_API + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        console.log(url, response.data);
        resolve(response.data);
      }).catch(error => {
        console.error("API Error:", error);
        resolve({
          status: 0,
          msg: "Network Connection Error",
        });
      });
      
    });
  });
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('adminId');
    let userToken = getCookie('adminToken');
    let userType = getCookie('adminType');

    resolve({
      userId,
      userToken,
      userType,
    })


  })
}

export function setCookie(cname, cvalue, exdays) {
  cname = 'bob-admin-'+cname;
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  cname = 'bob-admin-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function formatMoney(x) {
  //round x to 2 decimal places before og function
  x = Number(x);
  x = x.toFixed(0);

  //then continue
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function stringToArray(string) {
  const array = string.split(",").map(item => item.trim());
  return array;
}

export function arrayToString(arr) {
  return arr.join(', ');
}
